import React from 'react';

import classes from '../../../App.module.css';
import ParamsList from 'components/betOffer-label/params-list/ParamsList';

const Description = () => {
    const { DescriptionItem } = classes;
    return (
        <div>
            <p className={DescriptionItem}>
                The formatting of the betOffer label is done based on the bet
                offer type, see in the examples below what data is needed
                depending on the betOffer.
            </p>
            <p className={DescriptionItem}>
                The betOfferLabel() method can accept a JSON with the below
                parameters.
            </p>
            <ParamsList />
            <p className={DescriptionItem}>
                <i>*required</i>
            </p>
            <p className={DescriptionItem}>
                <b>getTranslationCallback</b> - this method needs to be
                implemented at your end, and should be a callback that we'll
                receive some translations keys and needs to return the
                translated text. It means that you need to have your own
                translations handling, and you need to add the new keys from the
                examples below.
            </p>
        </div>
    );
};

export default Description;
